import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getRecurringDescription } from '../../utils/ganttUtils';

const GhostTaskTooltip = ({ task, originalTask }) => {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ p: 1 }}>
      <Box sx={{ mb: 1 }}>
        <Box sx={{
          fontSize: '14px',
          fontWeight: 600,
          fontStyle: 'italic'
        }}>
          {task.name}
        </Box>
        <Box sx={{
          fontSize: '12px',
          mt: 0.5
        }}>
          {t('common:gantt.recurring_instance', { number: task.instanceNumber })}
        </Box>
      </Box>

      <Box sx={{ fontSize: '11px' }}>
        <div>{t('common:labels.date')}: {task.startDate.toLocaleDateString()}</div>
        <div>{t('common:labels.date')}: {task.endDate.toLocaleDateString()}</div>
        <div>{t('common:gantt.pattern')}: {getRecurringDescription(originalTask)}</div>
        <div style={{ marginTop: '8px', fontStyle: 'italic' }}>
          {t('common:gantt.projected_occurrence')}
        </div>
      </Box>
    </Box>
  );
};

export default GhostTaskTooltip;
